import { FilterBoxConfig } from '@nx-fe/filter';
import { ColorConstants } from '../../../../../../xs-colors';
import { SummaryChartItem, UiSetting } from '../../../shared/models/chart.models';

export const APP_SPOTLIGHT_APP = 'app';
export const APP_SPOTLIGHT_APP_W = 'app_w';
export const APP_SPOTLIGHT_LIST_PAGE = 'as-list';
export const APP_SPOTLIGHT_INFO_PAGE = 'as-info';
export const APP_SPOTLIGHT_LIST_PAGE_W = 'as-list_w';
export const APP_SPOTLIGHT_INFO_PAGE_W = 'as-info_w';

export const APP_USAGE_APP = 'appusage';
export const APP_USAGE_PAGE = 'appusagepage';
export const APP_USAGE_SHIFT_PAGE = 'appusagepageshift';
export const APP_USAGE_SHIFT_APP = 'appusageshift';
export const APP_USAGE_DEVICE_TABLE = 'appUsageDeviceTable';
export const APP_USAGE_APP_TABLE = 'appUsageAppTable';
export const APP_USAGE_SHIFT_TABLE = 'apsDeviceTable';

export const APP_USAGE_SHIFT_PAGE_W = 'appusagepageshift_w';
export const APP_USAGE_SHIFT_APP_W = 'appusageshift_w';
export const APP_USAGE_SHIFT_TABLE_W = 'apsDeviceTable_w';

export const BATTERY_APP = 'batstats';
export const BATTERY_PAGE = 'batteryStatus';
export const BATTERY_TABLE = 'batstatstable';

export const WEB_APP_SPOTLIGHT_APP = 'webapp';
export const WEB_APP_SPOTLIGHT_LIST_PAGE = 'web-as-list';
export const WEB_APP_SPOTLIGHT_INFO_PAGE = 'web-as-info';

export const WEBAPP_USAGE_APP = 'webappusage';
export const WEBAPP_USAGE_PAGE = 'webappusagepage';
export const WEBAPP_USAGE_DEVICE_TABLE = 'webAppUsageDeviceTable';
export const WEBAPP_USAGE_APP_TABLE = 'webAppUsageAppTable';

export const APP_USAGE_APP_W = 'appusage_w';
export const APP_USAGE_PAGE_W = 'appusagepage_w';
export const APP_USAGE_DEVICE_TABLE_W = 'appUsageDeviceTable_w';
export const APP_USAGE_APP_TABLE_W = 'appUsageAppTable_w';

export const BATTERY_APP_W = 'batstats_w';
export const BATTERY_PAGE_W = 'batteryStatus_w';
export const BATTERY_TABLE_W = 'batstatstable_w';

export const DATA_USAGE_APP = 'datausage';
export const DATA_USAGE_PAGE = 'datausagepage';
export const DATA_USAGE_TABLE = 'datausagetable';

export const DATA_USAGE_APP_W = 'datausage_w';
export const DATA_USAGE_PAGE_W = 'datausagepage_w';
export const DATA_USAGE_TABLE_W = 'datausagetable_w';

export const LAST_KNOWN_APP = 'location_lastknown';
export const LAST_KNOWN_PAGE = 'last-known';
export const SIGNAL_STRENGTH_APP = 'location_signalstrength';
export const SIGNAL_STRENGTH_PAGE = 'signal-strength';

export const LAST_KNOWN_APP_W = 'location_lastknown_w';
export const LAST_KNOWN_PAGE_W = 'last-known_w';
export const SIGNAL_STRENGTH_APP_W = 'location_signalstrength_w';
export const SIGNAL_STRENGTH_PAGE_W = 'signal-strength_w';

export const WIFI_APP = 'wifi';
export const WIFI_PAGE = 'wifipage';
export const WIFI_TABLE = 'wfDeviceTable';
export const WIFI_APP_W = 'wifi_w';
export const WIFI_PAGE_W = 'wifipage_w';
export const WIFI_TABLE_W = 'wfDeviceTable_w';

export const DEVICE_APP = 'device';
export const DEVICE_APP_W = 'device_w';
export const DEVICE_LIST = 'device-list';
export const DEVICE_LIST_W = 'device-list_w';
export const DEVICE_SUMMARY = 'device-summary';
export const DEVICE_BATTERY_USAGE = 'device-batteryUsage';
export const DEVICE_WEBAPP_USAGE = 'device-webappUsage';
export const DEVICE_APP_USAGE = 'device-appUsage';
export const DEVICE_BATTERY_USAGE_W = 'device-batteryUsage_w';
export const DEVICE_DATA_USAGE = 'device-dataUsage';
export const DEVICE_DATA_USAGE_W = 'device-dataUsage_w';
export const DEVICE_LAST_KNOWN = 'device-last-known';
export const DEVICE_SIGNAL_STRENGTH = 'device-signal-strength';
export const DEVICE_SIGNAL_STRENGTH_W = 'device-signal-strength_w';
export const DEVICE_WIFI = 'device-wifi';

export const SMART_BATTERY_APP = 'smartbattery';
export const SMART_BATTERY_PAGE = 'smartbatterypage';
export const SMART_BATTERY_TABLE = 'sbTable';
export const SMART_BATTERY_DECOMTABLE = 'sbTableDecom';
export const SMART_BATTERY_HEALTH = 'sbHealth';
export const SMART_BATTERY_SPOTLIGHT = 'sb-spotlight';
export const SMART_BATTERY_DECOMPAGE = 'smartbatterydecompage';
export const SMART_BATTERY_NEWPAGE = 'smartbatterynewpage';
export const SMART_BATTERY_ALLPAGE = 'smartbatteryinvpage';
export const SMART_BATTERY_AGE = 'sbAge';
export const SMART_BATTERY_CYCLES = 'sbCyclesEx';
export const SMART_BATTERY_REMAINING_BATTERY_CAPACITY = 'sbEstCapacityEx';
export const SMART_BATTERY_CHARGE_LEVEL = 'sbChargeLevel';
export const SMART_BATTERY_LAST_UPDATED = 'sbLastUpdated';
export const SMART_BATTERY_INV_LAST_UPDATED = 'sbInvLastUpdated';
export const WATCHLIST_APP = 'watchlist';

export const WATCHLIST_CURRENT_APP = 'watchlist_current';
export const WATCHLIST_DEPARTED_APP = 'watchlist_departed';
export const WATCHLIST_PAGE = 'watchpage';
export const WATCHLIST_CURRENT_PAGE = 'watchpagecurrent';
export const WATCHLIST_DEPARTED_PAGE = 'watchpagedeparted';
export const WATCHLIST_CURRENT_TABLE = 'wlcTable';
export const WATCHLIST_DEPARTED_TABLE = 'wldTable';

export const UTILIZATION_DEVICE_APP = 'ps_device';
export const UTILIZATION_STORE_APP = 'ps_store';
export const UTILIZATION_DEVICE_PAGE = 'pspagedevice';
export const UTILIZATION_STORE_PAGE = 'pspagebystore';
export const PS_DEVICE_TABLE = 'psdTable';

export const BATTERY = 'battery';
export const APPLICATIONS = 'applications';
export const LOCATION = 'location';

export const FILTER_VALIDATION_NONEMPTY_SAFE_TEXT = '^(?:(?![\n\b\t\r\0]).){1,}$';

export const DEFAULT_APP_FILTER_BAR_CONFIG: FilterBoxConfig = {
  autoUpdate: false,
  andOnly: true,
  showReset: true,
  uniqueFields: true,
  fields: [
    {
      id: 'appExternalId',
      name: 'app_filter_appExternalId',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'appDisplayName',
      name: 'app_filter_appDisplayName',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'appCategory',
      name: 'app_filter_appCategory',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
  ],
};

const HOURS = [
  { label: '12 AM', value: '0:00' },
  { label: '1 AM', value: '1:00' },
  { label: '2 AM', value: '2:00' },
  { label: '3 AM', value: '3:00' },
  { label: '4 AM', value: '4:00' },
  { label: '5 AM', value: '5:00' },
  { label: '6 AM', value: '6:00' },
  { label: '7 AM', value: '7:00' },
  { label: '8 AM', value: '8:00' },
  { label: '9 AM', value: '9:00' },
  { label: '10 AM', value: '10:00' },
  { label: '11 AM', value: '11:00' },
  { label: '12 PM', value: '12:00' },
  { label: '1 PM', value: '13:00' },
  { label: '2 PM', value: '14:00' },
  { label: '3 PM', value: '15:00' },
  { label: '4 PM', value: '16:00' },
  { label: '5 PM', value: '17:00' },
  { label: '6 PM', value: '18:00' },
  { label: '7 PM', value: '19:00' },
  { label: '8 PM', value: '20:00' },
  { label: '9 PM', value: '21:00' },
  { label: '10 PM', value: '22:00' },
  { label: '11 PM', value: '23:00' },
];

export const DEFAULT_WEBAPP_FILTER_BAR_CONFIG: FilterBoxConfig = {
  autoUpdate: false,
  andOnly: true,
  showReset: true,
  uniqueFields: true,
  fields: [
    {
      id: 'webAppName',
      name: 'webApp_filter_webAppName',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'category',
      name: 'webApp_filter_webAppCategory',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
  ],
};

export const DEFAULT_DEVICE_FILTER_BAR_CONFIG: FilterBoxConfig = {
  autoUpdate: false,
  andOnly: true,
  showReset: true,
  uniqueFields: true,
  fields: [
    {
      id: 'deviceId',
      name: 'Device_Filter_Item_Device_ID',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'deviceName',
      name: 'Device_Filter_Item_Device_Name',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'macAddress',
      name: 'Device_Filter_Item_MAC_Address',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'manufacturer',
      name: 'Device_Filter_Item_Manufacturer',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    { id: 'model', name: 'Device_Filter_Item_Model', type: 'string', validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT },
    {
      id: 'osVersion',
      name: 'Device_Filter_Item_OS_Version',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'serialNumber',
      name: 'Device_Filter_Item_Serial_Number',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
  ],
};

export const SNOOZED_DEVICES_FILTER_BAR_CONFIG: FilterBoxConfig = {
  autoUpdate: false,
  andOnly: true,
  showReset: true,
  uniqueFields: true,
  fields: [
    {
      id: 'deviceId',
      name: 'Device_Filter_Item_Device_ID',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'deviceName',
      name: 'Device_Filter_Item_Device_Name',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    {
      id: 'manufacturer',
      name: 'Device_Filter_Item_Manufacturer',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    { id: 'model', name: 'Device_Filter_Item_Model', type: 'string', validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT },
    {
      id: 'osVersion',
      name: 'Device_Filter_Item_OS_Version',
      type: 'string',
      validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT,
    },
    // { id: 'snoozedFor', name: 'Snoozed For', type: 'string', validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT },
    // { id: 'profileName', name: 'Profile Name', type: 'string', validation: FILTER_VALIDATION_NONEMPTY_SAFE_TEXT },
  ],
};

export const CHART_UI_BAR_TOPN: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_name',
  options: [
    {
      label: '3',
      value: 3,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '15',
      value: 15,
    },
    {
      label: '20',
      value: 20,
    },
  ],
};

export const CHART_UI_BAR_PERCENTAGE: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_percentage_name',
  options: [
    {
      label: '50',
      value: 50,
    },
    {
      label: '60',
      value: 60,
    },
    {
      label: '70',
      value: 70,
    },
    {
      label: '80',
      value: 80,
    },
    {
      label: '90',
      value: 90,
    },
    {
      label: '100',
      value: 100,
    },
  ],
};

export const WF_CHART_UI_BAR_TOPN: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_name',
  options: [
    {
      label: '5',
      value: 5,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '15',
      value: 15,
    },
    {
      label: '20',
      value: 20,
    },
    {
      label: '25',
      value: 25,
    },
    {
      label: '30',
      value: 30,
    },
    {
      label: '40',
      value: 40,
    },
    {
      label: '50',
      value: 50,
    },
  ],
};

export const WF_SDD_CHART_UI_BAR_TOPN: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_name',
  options: [
    {
      label: '5',
      value: 5,
    },
    {
      label: '25',
      value: 25,
    },
    {
      label: '50',
      value: 50,
    },
  ],
};

export const CHART_UI_BAR_TOPN_MANY: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_name',
  options: [
    {
      label: '3',
      value: 3,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '15',
      value: 15,
    },
    {
      label: '20',
      value: 20,
    },
    {
      label: '30',
      value: 30,
    },
    {
      label: '40',
      value: 40,
    },
    {
      label: '50',
      value: 50,
    },
    {
      label: '60',
      value: 60,
    },
  ],
};

export const CHART_UI_DONUT_TOPN: UiSetting = {
  id: 'topN',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'common_chart_uiSettings_topN_name',
  options: [
    {
      label: '3',
      value: 3,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '15',
      value: 15,
    },
  ],
};

export const PS_CHART_UI_USAGE_WALL_MAX_MIN: UiSetting = {
  id: 'showTop',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'ps_chart_uiSettings_wall_usage_name',
  options: [
    {
      label: 'ps_chart_uiSettings_option_name_maximum',
      value: 1,
    },
    {
      label: 'ps_chart_uiSettings_option_name_minimum',
      value: 0,
    },
  ],
};

export const PS_CHART_UI_USAGE_DEVICE_MAX_MIN: UiSetting = {
  id: 'showTop',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'ps_chart_uiSettings_device_usage_name',
  options: [
    {
      label: 'ps_chart_uiSettings_option_name_maximum',
      value: 1,
    },
    {
      label: 'ps_chart_uiSettings_option_name_minimum',
      value: 0,
    },
  ],
};

export const PS_CHART_UI_USAGE_DATE_HOUR: UiSetting = {
  id: 'byDay',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'ps_chart_uiSettings_usage_by_name',
  options: [
    {
      label: 'hour_label',
      value: 0,
    },
    {
      label: 'date_label',
      value: 1,
    },
  ],
};

export const PS_CHART_UI_USAGE_BY_STORE: UiSetting = {
  id: 'store',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  isDynamic: true,
  name: 'ps_chart_uiSettings_select_store_name',
  options: [],
};

export const CHART_UI_EXCLUDE_HOURS: UiSetting = {
  id: 'excludeHours',
  controlType: 'CHECKBOX_WITH_DROPDOWN',
  type: 'number',
  name: '',
  options: [
    {
      label: 'ps_chart_uiSettings_exclude_hours_label',
      value: null,
    },
  ],
  infoText: 'avg_wall_time_chart_settings_info_text',
  childOptions: [
    {
      id: 'exStart',
      controlType: 'SELECTBOX',
      type: 'number',
      name: 'ps_chart_uiSettings_exclude_hours_select_label_before',
      options: HOURS,
    },
    {
      id: 'exEnd',
      controlType: 'SELECTBOX',
      type: 'number',
      name: 'ps_chart_uiSettings_exclude_hours_select_label_after',
      options: HOURS,
    },
  ],
};

export const STARTING_CHARGE_LEVEL_COLORS = [
  { color: ColorConstants.sotiColors('gradient', 5), label: '0-9%' },
  { color: ColorConstants.sotiColors('gradient', 10), label: '10-19%' },
  { color: ColorConstants.sotiColors('gradient', 20), label: '20-29%' },
  { color: ColorConstants.sotiColors('gradient', 30), label: '30-39%' },
  { color: ColorConstants.sotiColors('gradient', 40), label: '40-49%' },
  { color: ColorConstants.sotiColors('gradient', 50), label: '50-59%' },
  { color: ColorConstants.sotiColors('gradient', 60), label: '60-69%' },
  { color: ColorConstants.sotiColors('gradient', 70), label: '70-79%' },
  { color: ColorConstants.sotiColors('gradient', 80), label: '80-89%' },
  { color: ColorConstants.sotiColors('gradient', 90), label: '90-100%' },
  { color: ColorConstants.sotiColors('grey', 40), label: '{NO_DATA}' },
];

export const CHART_UI_DONUT_LEAST_MOST: UiSetting = {
  id: 'mostLeast',
  controlType: 'SELECTBOX',
  type: 'number',
  displayType: 'dropdown',
  name: 'select_box_label_order_by',
  options: [
    {
      label: 'most_chart_label',
      value: 1,
    },
    {
      label: 'least_chart_label',
      value: -1,
    },
  ],
};

export const DEVICE_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_mc_devices_tooltip',
    children: [
      {
        key: 'xsDevices',
        label: 'devices_summary_xs_devices',
        color: '206, 224, 246',
        tooltip: 'devices_summary_xs_devices_tooltip',
      },
    ],
  },
  {
    key: 'devicesReporting',
    label: 'devices_summary_devices_reporting',
    color: '206, 224, 246',
    tooltip: 'devices_summary_reporting_devices',
    children: [
      {
        key: 'devicesFiltered',
        label: 'devices_summary_devices_filtered',
        color: '206, 224, 246',
        tooltip: 'devices_summary_filter_devices',
      },
    ],
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const APP_SHIFT_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_app_usage_shift_mobicontrol_devices_tooltip',
    children: [
      {
        key: 'xsDevices',
        label: 'devices_summary_xs_devices',
        color: '206, 224, 246',
        tooltip: 'devices_summary_app_usage_shift_xsight_devices_tooltip',
      },
    ],
  },
  {
    key: 'devicesReporting',
    label: 'devices_summary_devices_reporting_usage',
    color: '206, 224, 246',
    tooltip: 'devices_summary_app_usage_shift_reporting_devices_tooltip',
    children: [
      {
        key: 'devicesFiltered',
        label: 'devices_summary_devices_filtered',
        color: '206, 224, 246',
        tooltip: 'devices_summary_app_usage_shift_filter_devices_tooltip',
      },
    ],
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const WEB_APP_USAGE_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_web_app_usage_mobicontrol_devices_tooltip',
    children: [
      {
        key: 'xsDevices',
        label: 'devices_summary_xs_devices',
        color: '206, 224, 246',
        tooltip: 'devices_summary_web_app_usage_xsight_devices_tooltip',
      },
    ],
  },
  {
    key: 'devicesReporting',
    label: 'devices_summary_devices_reporting_usage',
    color: '206, 224, 246',
    tooltip: 'devices_summary_web_app_usage_reporting_devices_tooltip',
    children: [
      {
        key: 'devicesFiltered',
        label: 'devices_summary_devices_filtered',
        color: '206, 224, 246',
        tooltip: 'devices_summary_web_app_usage_filter_devices_tooltip',
      },
    ],
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const WATCHLIST_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'xsDevices',
    label: 'wl_summary_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_current_selected_groups_tooltip',
    children: [
      {
        key: 'wlDevices',
        label: 'wl_summary_one_condition',
        color: '206, 224, 246',
        tooltip: 'devices_summary_watchlist_current_condition_tooltip',
      },
    ],
  },
  {
    key: 'devicesLast1',
    label: 'wl_summary_last_1',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_current_past_24_hours_tooltip',
  },
  {
    key: 'devicesLast7',
    label: 'wl_summary_last_7',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_current_past_7_days_tooltip',
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const WATCHLIST_DEPARTED_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'xsDevices',
    label: 'wl_summary_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_departed_selected_groups_tooltip',
  },
  {
    key: 'devicesLast1',
    label: 'wl_departed_summary_last_1',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_departed_past_24_hours_tooltip',
  },
  {
    key: 'devicesLast7',
    label: 'wl_departed_summary_last_7',
    color: '206, 224, 246',
    tooltip: 'devices_summary_watchlist_departed_past_7_days_tooltip',
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const APP_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    children: [
      {
        key: 'xsDevices',
        label: 'devices_summary_xs_devices',
        color: '206, 224, 246',
        tooltip: 'devices_summary_app_usage_xsight_devices_tooltip',
      },
    ],
    tooltip: 'devices_summary_app_usage_mobicontrol_devices_tooltip',
  },
  {
    key: 'devicesFiltered',
    label: 'devices_summary_devices_filtered_on_dash',
    color: '206, 224, 246',
    tooltip: 'devices_summary_app_usage_filter_devices_tooltip',
  },
  {
    key: 'devicesReporting',
    label: 'devices_summary_devices_reporting_usage',
    color: '206, 224, 246',
    tooltip: 'devices_summary_app_usage_reporting_devices_tooltip',
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const CELULAR_SUMMARY_CHART_ITEMS: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_mc_devices_tooltip',
    children: [
      {
        key: 'xsDevices',
        label: 'devices_summary_xs_devices',
        color: '206, 224, 246',
        tooltip: 'devices_summary_xs_devices_tooltip',
      },
    ],
  },
  {
    key: 'devicesReporting',
    label: 'devices_summary_devices_reporting',
    color: '206, 224, 246',
    tooltip: 'devices_summary_reporting_devices',
    children: [
      {
        key: 'devicesFiltered',
        label: 'devices_summary_devices_filtered',
        color: '206, 224, 246',
        tooltip: 'devices_summary_filter_devices',
      },
    ],
  },
  {
    key: 'devicesPoints',
    label: 'cellular_summary_enabled_points',
    color: '206, 224, 246',
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];

export const PS_DEVICE_UTILIZATION_SUMMARY: SummaryChartItem[] = [
  {
    key: 'mcDevices',
    label: 'devices_summary_mc_devices',
    color: '206, 224, 246',
    tooltip: 'devices_summary_ps_util_usage_mobicontrol_devices_tooltip',
    children: [
      {
        key: '',
        label: 'psd_summary_devices_xsight_title',
        color: '206, 224, 246',
        tooltip: 'devices_summary_ps_util_xsight_devices_tooltip',
        childrenInSameContainer: [
          {
            key: 'xsDevices',
            label: 'psd_summary_devices_xsight_enrolled',
            color: '206, 224, 246',
            tooltip: 'devices_summary_ps_util_xsight_devices_tooltip',
          },
          {
            key: 'devicesConnected',
            label: 'psd_summary_devices_xsight_connected',
            color: '206, 224, 246',
            tooltip: 'devices_summary_ps_util_xsight_devices_tooltip',
          },
        ],
      },
    ],
  },
  {
    key: 'lastUpdatedTime',
    label: 'summary_last_updated_time_format',
    style: 'last_updated',
  },
];
